export default `:host {
  display: inline-block;
  max-width: 100%;
}

:host([size=full]) {
  width: 100%;
  height: inherit;
}

:host([size=sm]) .ids-image,
.ids-image.sm {
  width: 60px;
  height: 60px;
}

:host([size=md]) .ids-image,
.ids-image.md {
  width: 154px;
  height: 120px;
}

:host([size=lg]) .ids-image,
.ids-image.lg {
  width: 300px;
  height: 350px;
}

:host([size=full]) .ids-image,
.ids-image.full {
  width: 100%;
  height: 100%;
}

:host([size=lg]) .ids-image:not(.placeholder):not(.initials),
:host([size=md]) .ids-image:not(.placeholder):not(.initials),
:host([size=sm]) .ids-image:not(.placeholder):not(.initials) {
  object-fit: contain;
}

:host([round=true][size=sm]) .ids-image,
.ids-image.round.sm {
  width: 60px;
  height: 60px;
}

:host([round=true][size=md]) .ids-image,
.ids-image.round.md {
  width: 120px;
  height: 120px;
}

:host([round=true][size=lg]) .ids-image,
.ids-image.round.lg {
  width: 300px;
  height: 300px;
}

:host([round=true][size=full]) .ids-image,
.ids-image.round.full {
  width: 100%;
  height: 100%;
}

:host(:focus-visible) {
  outline: none;
}

:host(:focus) .ids-image,
:host(:focus-visible) .ids-image {
  border-color: var(--ids-image-color-border-focus);
  box-shadow: var(--ids-image-shadow-focus);
}

:host .placeholder,
.ids-image.placeholder {
  border-radius: var(--ids-image-placeholder-border-radius);
  border-color: var(--ids-image-color-border-default);
}
:host .placeholder ids-icon,
.ids-image.placeholder ids-icon {
  color: var(--ids-image-color-text);
}

:host([round=true]) .ids-image,
.ids-image.round {
  border-radius: 50%;
}

:host([user-status]),
.user-status-wrapper {
  position: relative;
}

:host(.disabled),
:host([disabled]) {
  opacity: var(--ids-list-view-item-opacity-disabled);
}

.ids-image {
  box-sizing: border-box;
  border: 1px solid transparent;
  max-width: 100%;
  height: auto;
}
.ids-image:not(.placeholder):not(.initials) {
  display: inline-block;
  object-fit: var(--ids-image-object-fit, cover);
}
.ids-image.placeholder {
  align-items: center;
  display: inline-flex;
  background-color: var(--ids-image-placeholder-color-background);
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
}
.ids-image.initials {
  align-items: center;
  display: flex;
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
  background-color: var(--ids-image-initials-color-background);
  color: var(--ids-color-white-100);
  text-transform: uppercase;
}
.ids-image .audible {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.user-status {
  position: absolute;
  width: 18px;
  height: 18px;
  right: -1px;
  bottom: -3px;
}
.user-status.available {
  color: var(--ids-image-status-available-color-background);
}
.user-status.busy, .user-status.do-not-disturb {
  color: var(--ids-image-status-busy-color-background);
}
.user-status.away {
  color: var(--ids-image-status-away-color-background);
}
.user-status.unknown {
  fill: var(--ids-image-status-unknown-color-background);
  color: var(--ids-color-transparent);
}
.user-status.meeting {
  color: var(--ids-image-status-busy-color-background);
}
.user-status::before {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-white-100);
  content: "";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 3px;
  z-index: 1;
}
.user-status::after {
  position: absolute;
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
  content: "";
  width: 16px;
  height: 16px;
  left: 1px;
  top: 1px;
}
.user-status ids-icon {
  z-index: 1;
}

.user-status-wrapper .user-status svg {
  border-radius: var(--ids-image-border-radius);
  background-color: var(--ids-color-background-default);
}
.user-status-wrapper .user-status {
  position: unset;
  width: 18px;
  height: 18px;
  margin-left: 36px;
  margin-top: -18px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
